<template>
  <div v-if="link" class="news-cta">
    <LinkCallToAction
      :link="link"
      :link-label="linkLabel"
      default-label="Read Reference"
    />
  </div>
</template>

<script setup lang="ts">
import type { MultilinkStoryblok } from '~/types/storyblok'

defineProps<{
  link: MultilinkStoryblok
  linkLabel?: string
}>()
</script>

<style lang="less" scoped>
.news-cta {
  margin: @gutter-xl 0;
}
</style>
